import { render, staticRenderFns } from "./MainMenuRearrangementDialog.vue?vue&type=template&id=457324ec&scoped=true&"
import script from "./MainMenuRearrangementDialog.vue?vue&type=script&lang=js&"
export * from "./MainMenuRearrangementDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuRearrangementDialog.vue?vue&type=style&index=0&id=457324ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457324ec",
  null
  
)

export default component.exports